export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=1f94f4a6&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/rating-history/index.vue?vue&type=template&id=1f94f4a6&
// module id = 1465
// module chunks = 0